import React, { Suspense } from 'react'
import { LoadingComponent } from '../../loading/index'

const DevicesAndDownloads = React.lazy(() => import('./devices-and-downloads'))

const AsyncDevicesAndDownloads = props => (
  <Suspense fallback={<LoadingComponent />}>
    <DevicesAndDownloads {...props} />
  </Suspense>
)

export default AsyncDevicesAndDownloads
